// @flow
import { type PriceRemoteState } from 'Store/price-remote/priceRemote.reducer';

export const priceRemoteSelector = ({ priceRemote }: { priceRemote: PriceRemoteState }) =>
  priceRemote || {};
